
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trending-list/[id]",
      function () {
        return require("private-next-pages/trending-list/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trending-list/[id]"])
      });
    }
  